module.exports = __webpack_public_path__ + "img/profess6.380f0009.png";